import { ServiceTypeItemOfferingType } from '@nile/banyan/src/Pages/ServiceCatalogNew/types.ts';

export const OFFERING_TYPES: Record<
  'PRODUCT' | ServiceTypeItemOfferingType,
  {
    key: string,
    icon: string
  }
> = {
  HOURS: {
    key: 'admin.serviceCatalog.itemType.service.offeringType.hour',
    icon: 'TimerNav'
  },
  QUANTITY: {
    key: 'admin.serviceCatalog.itemType.service.offeringType.quantity',
    icon: 'Cart'
  },
  PRODUCT: {
    key: 'admin.serviceCatalog.itemType.product.offeringType.quantity',
    icon: 'Puzzle'
  },
  BLOCK_HOUR: {
    key: 'admin.serviceCatalog.itemType.package.offeringType.blockHour',
    icon: 'HourglasswireEnd'
  },
  BLOCK_MONEY: {
    key: 'admin.serviceCatalog.itemType.package.offeringType.blockMoney',
    icon: 'Billable'
  },
  SERVICE_BUNDLE: {
    key: 'admin.serviceCatalog.itemType.package.offeringType.serviceBundle',
    icon: 'Cube'
  }
};
